
import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'bits/vue'
import OzIconButton, { OzIconButtonColorScheme } from 'library/v4/components/OzIconButton.vue'

@Component({ components: { OzIconButton } })
export default class OzBackButton extends Vue {
  ColorScheme = OzIconButtonColorScheme

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Button label.
   */
  @Prop({ default: __('Go back') }) label!: string
}
